{
  "required": "Ce champ est obligatoire",
  "email": {
    "invalid": "Saisissez un e-mail professionnel valide"
  },
  "password": {
    "required": "Le mot de passe est obligatoire"
  },
  "phone": {
    "maxDigits": "Maximum {{count}} chiffres pour {{country}}",
    "indianMobile": "Les numéros mobiles indiens commencent par 6 à 9"
  }
}
